var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-progress-bar",class:[_vm.colorVariant],attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":_vm.value}},[_c('div',{staticClass:"t-progress-bar__progress",style:({ width: _vm.width })})])
}
var staticRenderFns = []

export { render, staticRenderFns }